import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
// import { reducer as oidc } from 'redux-oidc'
import user from './user/reducers'
import menu from './menu/reducers'
import settings from './settings/reducers'
import productoReducer from './producto/reducers'
import categoriaReducer from './categoria/reducers'
import ivaReducer from './iva/reducers'
import urlReducer from './url/reducers'
import cartelReducer from './cartel/reducers'
import provinciaReducer from './provincia/reducers'
import fechaSenaladasReducer from './fechaSenalada/reducers'
import fechasSenaladasUrlReducer from './fechaSenaladaUrl/reducers'
import etiquetaReducer from './etiqueta/reducers'
import etiquetaUrlReducer from './etiquetaUrl/reducers'
import fechaNoEntregaReducer from './fechaNoEntrega/reducers'
import franjasHorariosReducer from './franjaHorario/reducers'
import diasEspecialesReducer from './diaEspecial/reducers'
import configuracionesCaso3BisReducer from './caso3bis/reducers'
import codigosPostalesConflictivosReducer from './codigoPostalConflictivo/reducers'
import paisesReducer from './paises/reducers'
import codigosPostalesInternacionalesReducer from './codigosPostalesInternacionales/reducers'
import horariosEntregaMadridReducer from './horarioEntregaMadrid/reducers'
import codigosPostalesReducer from './codigoPostal/reducers'
import consultaEmailsReducer from './consultaEmail/reducers'
import articulosReducer from './articulo/reducers'
import descuentosReducer from './descuentos/reducers'
import historialStocksReducer from './historialStock/reducers'
import frutasReducer from './fruta/reducers'
import proveedoresReducer from './proveedor/reducers'
import bannersReducer from './banner/reducers'
import categoriasHomeReducer from './categoriaHome/reducers'
import productosSemanaHomeReducer from './productosSemanaHome/reducers'
import traduccionesPaginaReducer from './traduccionPagina/reducers'
import urlGruposReducer from './urlGrupos/reducers'
import menuSitioReducer from './menuSitio/reducers'
import fechaBloqueadaReducer from './fechaBloqueada/reducers'
import paginaOkTemplateReducer from './paginaOkTemplate/reducers'
import mailTemplateReducer from './mailTemplate/reducers'
import ventasReducer from './venta/reducers'
import cacheReducer from './cache/reducers'
import horariosEntregaReducer from './horarioEntrega/reducers'
import bibPredSvgReducer from './bibpredsvg/reducers'
import bibPlantillaReducer from './bibplantilla/reducers'
import tiposSvgReducer from './tiposSvg/reducers'
import fontsReducer from './fonts/reducers'
import formasPagoReducer from './formaPago/reducers'
import estadosReducer from './estados/reducers'
import ladronesReducer from './ladron/reducers'
import fechaColorReducer from './fechaColor/reducers'
import distribuidoresReducer from './distribuidor/reducers'
import comboSvgReducer from './combossvg/reducers'
import dhlReducer from './dhl/reducers'
import bibPreguntaReducer from './bibpregunta/reducers'
import departamentoReducer from './departamento/reducers'
import usuarioReducer from './usuario/reducers'
import bibFamiliaReducer from './bibfamilia/reducers'
import etiquetaFamiliaReducer from './etiquetafamilia/reducers'
import bibFondoFamiliaReducer from './bibfondofamilia/reducers'
import personalizacionProductoReducer from './personalizacionProducto/reducers'
import colorLegoReducer from './colorlego/reducers'
import stickersReducer from './stickers/reducers'
import etiquetasComidasReducer from './etiquetasComidas/reducers'
import productosGenericosReducer from './productoGenerico/reducers'
import productosGenericosBocetosReducer from './productoGenericoBoceto/reducers'
import bibPrecioReducer from './bibPrecios/reducers'
import productosDesayunoReducer from './productosDesayuno/reducers'
import reclamacionesReducer from './reclamaciones/reducers'
import bibAvataresReducer from './avatares/reducers'
import lotesImpresionReducer from './lotesimpresion/reducers'
import transportistasReducer from './transportistas/reducers'
import codigoPostalRestriccionesMovilidadReducer from './codigoPostalRestriccionesMovilidad/reducers'
import restriccionEntregaReducer from './restriccionentrega/reducers'
import paisesInfoReducer from './paisesInfo/reducers'
import productosCajaReducer from './productosencaja/reducers'
import productosMasVendidosReducer from './productosMasVendidos/reducers'
import jobsReducer from './jobs/reducers'
import estadosUsuariosReducer from './estadosUsuarios/reducers'
import rolesAppReducer from './roles/reducers'
import firewallIpReducer from './firewallip/reducers'
import syncReducer from './sync/reducers'

export default history =>
  combineReducers({
    router: connectRouter(history),
    // oidc,
    user,
    menu,
    settings,
    categoriaReducer,
    productoReducer,
    ivaReducer,
    urlReducer,
    cartelReducer,
    provinciaReducer,
    fechaSenaladasReducer,
    fechasSenaladasUrlReducer,
    etiquetaReducer,
    etiquetaUrlReducer,
    fechaNoEntregaReducer,
    franjasHorariosReducer,
    diasEspecialesReducer,
    configuracionesCaso3BisReducer,
    codigosPostalesConflictivosReducer,
    paisesReducer,
    codigosPostalesInternacionalesReducer,
    horariosEntregaMadridReducer,
    codigosPostalesReducer,
    consultaEmailsReducer,
    articulosReducer,
    historialStocksReducer,
    frutasReducer,
    proveedoresReducer,
    bannersReducer,
    categoriasHomeReducer,
    productosSemanaHomeReducer,
    traduccionesPaginaReducer,
    urlGruposReducer,
    menuSitioReducer,
    fechaBloqueadaReducer,
    paginaOkTemplateReducer,
    mailTemplateReducer,
    ventasReducer,
    cacheReducer,
    descuentosReducer,
    horariosEntregaReducer,
    bibPredSvgReducer,
    tiposSvgReducer,
    fontsReducer,
    formasPagoReducer,
    estadosReducer,
    ladronesReducer,
    fechaColorReducer,
    distribuidoresReducer,
    bibPlantillaReducer,
    comboSvgReducer,
    dhlReducer,
    bibPreguntaReducer,
    departamentoReducer,
    usuarioReducer,
    bibFamiliaReducer,
    etiquetaFamiliaReducer,
    bibFondoFamiliaReducer,
    personalizacionProductoReducer,
    colorLegoReducer,
    stickersReducer,
    etiquetasComidasReducer,
    productosGenericosReducer,
    productosGenericosBocetosReducer,
    reclamacionesReducer,
    bibPrecioReducer,
    productosDesayunoReducer,
    bibAvataresReducer,
    lotesImpresionReducer,
    transportistasReducer,
    codigoPostalRestriccionesMovilidadReducer,
    restriccionEntregaReducer,
    paisesInfoReducer,
    productosCajaReducer,
    productosMasVendidosReducer,
    jobsReducer,
    syncReducer,
    estadosUsuariosReducer,
    rolesAppReducer,
    firewallIpReducer,
  })
